export const DEFAULT_DELAY_MESSAGE =
  '前の診察が長引いているため、診察開始が遅れております。\n 終わり次第、お呼び出しいたしますので、しばらくお待ちください。'
